import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

/**
 * The app's current text direction, resolved the same way App.tsx's
 * useSiteLang does (siteConfig.languages[code === currentLang].dir).
 *
 * The bot needs its own copy of this because the antd Drawer portals to
 * document.body — OUTSIDE the `<div className="App direction-…" dir="…">`
 * wrapper — so neither the dir attribute nor the `.direction-rtl/ltr` CSS
 * scope reaches the chat content on its own.
 */
export default function useAppDirection(): 'ltr' | 'rtl' {
  const { currentLang, config } = useSelector((s: RootState) => s.config);
  const dir = config?.siteConfig?.languages?.find(
    (l) => l.code === currentLang,
  )?.dir;
  return dir === 'rtl' ? 'rtl' : 'ltr';
}
